import React, { useEffect, useState } from "react";
import {
  Stack,
  Slider,
  Box,
  Checkbox,
  Button,
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
  Autocomplete,
  RadioGroup,
  FormLabel,
  FormControlLabel,
  Radio,
  ClickAwayListener,
} from "@mui/material";
import { useForm, Controller } from "react-hook-form";
import { styled } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import { UseSelector, useDispatch, useSelector } from "react-redux";
import {
  getQuestionIdData,
  editQuestionData,
  getQuestionsData,
} from "../../Redux/Questions/action";

import { environmentDetails } from "../../../src/environment/environment";
import { privateAxiosInstance } from "../../utils/axiosInstance";
import { accessTokenHeadersObject } from "../../utils/headers";
import { getProcessName } from "../../Redux/IFlowData/action";
import TemplateRepeater from "../../Pages/TemplateRepeater.jsx";
import ReuseableLabel from "../ReusableComponents/ReuseableLabel.jsx";
import {
  isContainsDoubleDollar,
  extractUnCommonWords,
  findSameQuestion2,
  findSimilarQuestions,
  getMasterTooltipMessage,
  isUploadDocumentQuestion,
  isNoticePeriodQuestion,
  isExperienceQuestion,
  isAudioQuestion,
  isVideoQuestion,
} from "../../utils/helperFunctions";
import { yupResolver } from "@hookform/resolvers/yup";
import { schema } from "../../constants/masterQuestion.js";
import { initailState } from "./Form.jsx";
import { useThrottle } from "../../hooks/useThrottle";
import DeleteAlert from "../AlertBox/DeleteAlert.jsx";
import {
  getAllDocumentCategoriesActionFn,
  getDocumentSubCategoriesActionFn,
} from "../../Redux/documentCategory/action.js";
import InfoBox from "../Common/InfoBox.jsx";
import axios from "axios";

// Import shared sections
import BasicSection from "./BasicSection";
import OtherSection from "./OtherSection";

const apiUrl = environmentDetails.apiUrl;

const PrettoSlider = styled(Slider)({
  color: "#52af77",
  height: 4,
  "& .MuiSlider-track": {
    border: "none",
  },
  "& .MuiSlider-thumb": {
    height: 24,
    width: 24,
    backgroundColor: "blue",
    border: "2px solid currentColor",
    "&:focus, &:hover, &.Mui-active, &.Mui-focusVisible": {
      boxShadow: "inherit",
    },
    "&:before": {
      display: "none",
    },
  },
  "& .MuiSlider-valueLabel": {
    lineHeight: 1.2,
    fontSize: 12,
    background: "unset",
    padding: 0,
    width: 25,
    height: 25,
    borderRadius: "50% 50% 50% 0",
    backgroundColor: "blue",
    transformOrigin: "bottom left",
    transform: "translate(50%, -100%) rotate(-45deg) scale(0)",
    "&:before": { display: "none" },
    "&.MuiSlider-valueLabelOpen": {
      transform: "translate(50%, -100%) rotate(-45deg) scale(1)",
    },
    "& > *": {
      transform: "rotate(45deg)",
    },
  },
});

const EditForm = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { qId } = useParams();
  const [data, setData] = useState(null);
  // console.log("data edit: ", data);
  const [recruiterCompanyDecLength, setRecruiterCompanyDecLength] = useState(0);
  const [questionTitle, setQuestionTitle] = useState("");
  const [isContainsDDollar, setIsContainsDDollar] = useState(false);
  const [filteredQuestions, setFilteredQuestions] = useState([]);
  const [masterQuestions, setMasterQuestions] = useState([]);
  const [open, setOpen] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [similarQuestinToEdit, setSimilarQuestionToEdit] = useState(null);
  const [isSameQuestionExist, setIsSameQuestionExist] = useState(false);
  const throlltedFunction = useThrottle();
  const [documentCategories, setDocumentCategories] = useState([]);
  const [documentSubCategories, setDocumentSubCategories] = useState([]);
  const [selectedSection, setSelectedSection] = useState(1);
  const [selectedDocumentCategoryItem, setSelectedDocumentCategoryItem] =
    useState(null);
  const processNameData = useSelector(
    (state) => state.iflowDataReducer.processName,
  );

  const handleClose = () => {
    setOpen(false);
  };
  var processVariables = [];

  useEffect(() => {
    privateAxiosInstance
      .get(
        `/questionnaire/get-que/${qId}?processName=Initiation_preScreeningProcess`,
        {
          headers: { ...accessTokenHeadersObject() },
        },
      )
      .then((res) => {
        setData(res.data.data);
        setQuestionTitle(res.data?.data?.Question);
      })
      .catch((err) => {
        console.log(err);
      });
    dispatch(getProcessName());
    dispatch(getQuestionsData(1, 5000)).then((res) => {
      if (res.type === "GET_QUESTIONS_SUCCESS") {
        setMasterQuestions(res.payload);
      } else {
        console.log("fetching master question error", res);
      }
    });
  }, []);

  useEffect(() => {
    if (questionTitle) {
      let res = isContainsDoubleDollar(questionTitle);
      if (res) {
        setIsContainsDDollar(true);
      } else {
        setIsContainsDDollar(false);
      }
    } else {
      setIsContainsDDollar(false);
    }
  }, [questionTitle]);

  const {
    register,
    handleSubmit,
    reset,
    control,
    watch,
    setValue,
    setFocus,
    formState: { errors },
  } = useForm({
    mode: "all",
    defaultValues: initailState,
    resolver: yupResolver(schema),
  });

  const expectDocumentWatch = watch("expectDocument");
  const documentTypeWatch = watch("documentType");
  const documentCategoryWatch = watch("documentCategory");
  const botInterpretedWatch = watch("Bot Interpreted");
  const botNameWatch = watch("Bot Name");
  const processVariableWatch = watch("Process Variable");
  const [questionData, setQuestionData] = useState({});

  useEffect(() => {
    setTimeout(() => {
      setQuestionData(data);
      if (data != null) {
        // console.log(data)
        setBotNameDisabled(false);
        if (data["Bot Interpreted"] == "n") {
          setBotNameDisabled(true);
        }
        setRecruiterCompanyDecLength(data["Job Description"].length);

        setTemplate([
          {
            templateName: data["Template Name"],
            paramNumber: "",
            params: [],
            verbiage: "",
          },
        ]);
      }
    });
  }, [data]);

  useEffect(() => {
    reset(questionData);
  }, [questionData]);
  useEffect(() => {
    // DOCUMENT CATEGORY WORK IN PROGESS
    if (expectDocumentWatch === "yes" && !documentCategories.length) {
      dispatch(getAllDocumentCategoriesActionFn()).then((res) => {
        if (res.type === "GET_DOCUMENT_CATEGORIES_SUCCESS") {
          setDocumentCategories(res.payload);
        } else {
          setDocumentCategories([]);
        }
      });
    }
    if (expectDocumentWatch === "no") {
      setValue("documentType", "");
      setValue("documentCategory", "");
    }
    if (botInterpretedWatch === "n") {
      setValue("Bot Name", "");
    } else if (botInterpretedWatch === data?.["Bot Interpreted"]) {
      setValue("Bot Name", data?.["Bot Name"]);
    }
  }, [expectDocumentWatch, botInterpretedWatch]);

  // console.log("ddddddddddd==> ", data);
  //var processVariables = []
  processNameData.map((val) => {
    if (val.processkey == "Initiation_preScreeningProcess") {
      processVariables = val.processDef.variables;
    }
  });

  const handleDescriptionKeyUp = (event) => {
    setRecruiterCompanyDecLength(event.target.value.length);
  };

  const [botInterpreted, setBotInterpreted] = useState();
  const [botNameDisabled, setBotNameDisabled] = useState(false);

  const handleBotInterpreted = (event) => {
    let curval = event.target.value;
    // console.log(curval)
    setBotInterpreted(curval);
    setBotNameDisabled(false);
    if (curval == "n") {
      setBotNameDisabled(true);
    }
  };

  const editMasterQuestionDispatchFn = (qId, data) => {
    dispatch(editQuestionData(qId, data)).then((res) => {
      if (res.type === `EDIT_QUESTIONS_SUCCESS`) {
        navigate("/questions");
      } else {
        console.log("edit master question err: ", res);
      }
    });
  };

  /*const onSubmit = (data) => {
    // data["Job Description"] = "https://ds-public-bucket-test.s3.amazonaws.com/DS/node.jpeg";
    let title = data.Question;
    let unCommonWords = extractUnCommonWords(title);
    data.keywords = unCommonWords;
    // let templateDetails = template;
    // data["Template Name"] = templateDetails[0]["templateName"];
    //if (filteredQuestions.length > 0) {
      setSimilarQuestionToEdit(data);
      setOpen(true);
      return;
    //}
    //editMasterQuestionDispatchFn(qId, data);
    // dispatch(editQuestionData(qId, data)).then((res) => {
    //   if (res.type === `EDIT_QUESTIONS_SUCCESS`) {
    //     navigate("/questions");
    //   } else {
    //     console.log("edit master question err: ", res);
    //   }
    // });
    // axios
    //   .put(`${apiUrl}questionnaire/update-que/${qId}`, data)
    //   .then((res) => {
    //     // console.log(res.data);
    //     navigate("/questions");
    //   })
    //   .catch((err) => {
    //     console.log(err);
    //   });
  };*/
  const onSubmit = (data) => {
    // Process keywords
    let title = data.Question;
    let unCommonWords = extractUnCommonWords(title);
    data.keywords = unCommonWords;
    let questionKeyword = data.keywords;
    console.log("questionKeyword", questionKeyword);

    // Check for upload document question
    const isUploadDoc = questionKeyword.some(isUploadDocumentQuestion);

    if (isUploadDoc) {
      data["Bot Interpreted"] = "n";
      data["Bot Name"] = "";
    } else {
      if (data["Bot Interpreted"] !== "y") {
        const BOT_RULES = [
          { check: isNoticePeriodQuestion, flag: "y", name: "noticePeriod" },
          {
            check: isExperienceQuestion,
            flag: "c",
            name: "checkNumeric#years",
          },
          { check: isAudioQuestion, flag: "v", name: "voiceScore" },
          { check: isVideoQuestion, flag: "v", name: "videoScore" },
        ];

        for (const rule of BOT_RULES) {
          if (questionKeyword.some(rule.check)) {
            data["Bot Interpreted"] = rule.flag;
            data["Bot Name"] = rule.name;
            break;
          }
        }
      }
    }

    // Special case for yesOrNo
    if (data["Bot Name"] === "yesOrNo") {
      data["Bot Interpreted"] = "y";
    }

    // Fixed fields
    data["Path"] = "y";
    data["yPath"] = "";
    data["nPath"] = "";
    data["Adaptive"] = "y";
    data["defaultValue"] = "";

    console.log("final data", data);

    // Show popup for confirmation
    setSimilarQuestionToEdit(data);
    setOpen(true);
    return;
  };
  const handleSimilarQuestionSubmit = () => {
    editMasterQuestionDispatchFn(qId, similarQuestinToEdit);
    handleClose();
    //console.log("handle similar question submit ",similarQuestinToSave);
  };

  const onQuestionTitleKeyUp = (e) => {
    let value = e.target.value;
    if (e.keyCode != 27) setMenuOpen(true);
    else setMenuOpen(false);
    setQuestionTitle(value);
    let throttleFunc = throlltedFunction(
      (value) => handleThrottleFunction(value),
      800,
    );
    throttleFunc(value);
  };

  const handleTab = (e) => {
    if (e.keyCode != 9) setMenuOpen(true);
    else setMenuOpen(false);
  };

  const handleCloseMenu = () => {
    setMenuOpen(false);
  };

  const handleMenuItemClick = (question) => {
    //reset({Question:question.Question});

    setMenuOpen(false);
    // console.log("Selected question  ", question);
  };

  let keyWordsQues = masterQuestions?.filter((ques) => ques.keywords);
  const handleThrottleFunction = (input) => {
    let similarQues = findSimilarQuestions(input, keyWordsQues, qId);
    if (input && similarQues.length > 0) {
      let sameQuestion = findSameQuestion2(input, similarQues);
      if (sameQuestion.length > 0) {
        setIsSameQuestionExist(true);
      } else {
        setIsSameQuestionExist(false);
      }
      setFilteredQuestions(similarQues);
    } else {
      setFilteredQuestions([]);
    }
  };

  const [template, setTemplate] = useState([
    { templateName: "", paramNumber: "", params: [], verbiage: "" },
  ]);

  // DOCUMENT CATEGORY WORK IN PROGESS
  // const handleCategoryOnChange = (event) => {
  //   let selectedDocumentType = event.target.value;
  //   //setSelectedDocumentCategoryItem(selectedDocumentType)
  //   if (selectedDocumentType === "KYC" && !documentSubCategories.length) {
  //     dispatch(getDocumentSubCategoriesActionFn()).then((res) => {
  //       if (res.type === "GET_DOCUMENT_SUB_CATEGORIES_SUCCESS") {
  //         setDocumentSubCategories(res.payload);
  //       }
  //     });
  //   } else {
  //     setDocumentSubCategories([]);
  //     console.log("eeeeeeeee ", event.target.value);
  //   }
  // };

  const scoringEngine = watch("Scoring Engine");

  useEffect(() => {
    if (scoringEngine === true) {
      getScoringEngineFieldName();
    } else {
      setValue("Scoring Engine Field Name", "");
    }
  }, [scoringEngine]);

  const getScoringEngineFieldName = () => {
    axios
      .post(`${apiUrl}scoringEngineFieldName/generate`, {
        question: questionTitle,
      })
      .then((res) => {
        setValue("Scoring Engine Field Name", res.data.data);
        setFocus("Scoring Engine Field Name");
      })
      .catch((err) => {
        console.log(err);
      });
  };
  useEffect(() => {
    if (documentCategoryWatch === "KYC" && !documentSubCategories.length) {
      if (questionData?.documentType)
        setValue("documentType", data.documentType);
      dispatch(getDocumentSubCategoriesActionFn()).then((res) => {
        if (res.type === "GET_DOCUMENT_SUB_CATEGORIES_SUCCESS") {
          setDocumentSubCategories(res.payload);
        }
      });
    } else {
      setDocumentSubCategories([]);
      setValue("documentType", "");
      //console.log("eeeeeeeee ", event.target.value);
    }
  }, [documentCategoryWatch, setValue]);
  return (
    <Box
      sx={{
        height: "90%",
        width: "100%",
        overflowY: "auto",
        overflowX: "auto",
      }}
    >
      <Box
        sx={{
          width: "80%", // Changed from 986px
          margin: "auto",
          boxSizing: "border-box",
          // Made padding responsive
          paddingLeft: {
            xs: "0",
            sm: "50px",
            md: "50px",
            lg: "50px",
            xl: "50px",
          },
          paddingRight: {
            xs: "0",
            sm: "50px",
            md: "50px",
            lg: "50px",
            xl: "50px",
          },
        }}
      >
        {/* Added Alert */}
        <Typography
          variant="h4"
          component="h2"
          // Changed sx to style
          style={{ marginBottom: "15px", marginTop: 0 }}
        >
          Edit Master Question
        </Typography>

        {questionData && (
          <form onSubmit={handleSubmit(onSubmit)}>
            {/* QUESTION  */}
            <Box
              sx={{
                width: "100%",
                position: "relative",
              }}
            >
              <TextField
                fullWidth
                // multiline // Removed multiline
                variant="outlined"
                autoComplete="off" // Added autoComplete
                type="text"
                label={<ReuseableLabel label={"Question"} />}
                name="Question"
                maxRows={2} // Added maxRows
                placeholder="Add Your Question here"
                InputProps={{ sx: { borderRadius: "6px" } }}
                style={{ width: "100%", height: "auto" }}
                {...register("Question", { required: "Question is Required" })}
                onKeyUp={onQuestionTitleKeyUp}
                onKeyDown={handleTab}
                error={Boolean(errors.Question)}
                helperText={errors.Question?.message}
              />
              {filteredQuestions.length > 0 && (
                <Box
                  sx={{
                    height: "fitcontent",
                    maxHeight: "200px",
                    overflowY: "auto",
                    overflowX: "auto",
                    boxShadow: 3,
                    borderBottomRightRadius: "7px",
                    borderBottomLeftRadius: "7px",
                  }}
                >
                  {/* Wrapped in fragment */}
                  <>
                    {filteredQuestions.map((item, idx) => {
                      return (
                        <ClickAwayListener onClickAway={handleCloseMenu}>
                          {menuOpen ? (
                            <MenuItem
                              onClick={() => {
                                handleMenuItemClick(item);
                              }}
                              key={idx}
                            >
                              {item.Question}
                            </MenuItem>
                          ) : (
                            <></>
                          )}
                        </ClickAwayListener>
                      );
                    })}
                  </>
                </Box>
              )}
            </Box>
            {/* DESCRIPTION - Replaced commented section with fragment */}
            <></>
            <Box
              sx={{
                width: "100%", // Changed width to 100%
                mt: "20px",
              }}
            >
              <FormControl component="fieldset">
                <FormLabel component="legend">Attach Job Description</FormLabel>
                <Controller
                  rules={{ required: true }}
                  control={control}
                  name="Attach Job Description"
                  defaultValue="n"
                  render={({ field }) => (
                    <RadioGroup
                      row
                      {...field}
                      value={field.value || "n"}
                      onChange={(e) => field.onChange(e.target.value)}
                    >
                      <FormControlLabel
                        value="y"
                        control={<Radio />}
                        label="Yes"
                      />

                      <FormControlLabel
                        value="n"
                        control={<Radio />}
                        label="No"
                      />
                    </RadioGroup>
                  )}
                />
              </FormControl>
            </Box>

            <Box
              sx={{
                display: "flex",
                gap: "3px",
                mt: 3,
                justifyContent: "flex-start",
                flexWrap: "wrap",
              }}
            >
              {[
                { id: 1, label: "Basic Section" },
                { id: 2, label: "Other Section" },
              ].map((tab) => (
                <Box
                  key={tab.id}
                  onClick={() => setSelectedSection(tab.id)}
                  sx={{
                    cursor: "pointer",
                    px: 2,
                    py: 1,
                    borderRadius: 2,
                    fontWeight: 500,
                    fontSize: "0.95rem",
                    transition: "all 0.3s ease",
                    backgroundColor:
                      selectedSection === tab.id ? "#092244" : "#f0f0f0",
                    color: selectedSection === tab.id ? "white" : "#333",
                    "&:hover": {
                      backgroundColor:
                        selectedSection === tab.id ? "#092244" : "#e0e0e0",
                      color: selectedSection === tab.id ? "white" : "#000",
                    },
                  }}
                >
                  {tab.label}
                </Box>
              ))}
            </Box>

            <Box
              sx={{
                height: "auto",
                // Removed marginTop: "auto" - handled by tab content spacing
              }}
            >
              <Stack direction="row" gap={5} sx={{ width: "100%" }}>
                {/* --- Conditional Rendering for Tabs --- */}
                {selectedSection === 1 ? (
                  /*
                  // --- BOT SECTION CONTENT ---
                  <>
                    <Stack
                      direction={"column"}
                      gap={2}
                      // Added responsive width and margin auto
                      width={{
                        md: "80%",
                        lg: "80%",
                        xl: "80%",
                        sm: "100%",
                        xs: "100%",
                      }}
                      margin={"0 auto"}
                      mt={"20px"}
                    >
                      <Box
                        width={"100%"}
                        height={"auto"}
                        sx={{ border: "0px solid green" }}
                      >
                        {" "}
                        // Added border
                        // Removed Bot Section Typography Header
                        <Box
                          style={{
                            // Changed sx to style
                            width: "auto",
                            justifyContent: "center",
                            alignItems: "center",
                            borderRadius: "7px",
                          }}
                        >
                          <Stack
                            direction="column"
                            sx={{ border: "0px solid blue" }}
                          >
                            {" "}
                            // Added border
                            <Box
                              sx={{
                                border: "0px solid red", // Added border
                                display: "flex",
                                alignItems: "center",
                                gap: "5px",
                              }}
                            >
                              {botInterpretedWatch?.length > 0 && (
                                <InfoBox
                                  message={getMasterTooltipMessage(
                                    "botInterpreted",
                                    botInterpretedWatch
                                  )}
                                />
                              )}
                              <FormControl
                                variant="outlined"
                                style={{ marginTop: 1, minWidth: 150 }}
                                size="small"
                                fullWidth
                                error={Boolean(errors?.["Bot Interpreted"])} // Added error
                              >
                                <InputLabel>
                                  <ReuseableLabel label={"Bot Interpreted"} />
                                </InputLabel>
                                <Controller
                                  name="Bot Interpreted"
                                  control={control}
                                  defaultValue=""
                                  rules={{
                                    required: "Please select an option",
                                  }}
                                  render={({ field }) => (
                                    <>
                                      <Select
                                        {...field}
                                        label="Bot Interpreted"
                                        id="demo-simple-select-required"
                                        labelId="demo-simple-select-required-label"
                                        defaultValue="n" // Changed default value
                                        onChange={(e) => {
                                          handleBotInterpreted(e);
                                          field.onChange(e);
                                        }}
                                        error={Boolean(
                                          errors?.["Bot Interpreted"]
                                        )}
                                      >
                                        <MenuItem value="">
                                          Select an option
                                        </MenuItem>
                                        <MenuItem value="y">Yes</MenuItem>
                                        <MenuItem value="n">No</MenuItem>
                                        <MenuItem value="c">Custom</MenuItem>
                                        <MenuItem value="g">ChatGpt</MenuItem>
                                        <MenuItem value="v">Score</MenuItem>
                                      </Select>
                                      {errors?.["Bot Interpreted"] && (
                                        <FormHelperText error>
                                          {errors?.["Bot Interpreted"]?.message}
                                        </FormHelperText>
                                      )}
                                    </>
                                  )}
                                />
                              </FormControl>
                            </Box>
                            <Box
                              sx={{
                                // Removed border
                                display: "flex",
                                alignItems: "center",
                                gap: "5px",
                              }}
                            >
                              {botNameWatch?.length > 0 && (
                                <InfoBox
                                  message={getMasterTooltipMessage(
                                    "botName",
                                    botNameWatch
                                  )}
                                />
                              )}
                              <FormControl
                                variant="outlined"
                                fullWidth // Added fullWidth
                                style={{ marginTop: 11, minWidth: 150 }}
                                size="small"
                                error={Boolean(errors?.["Bot Name"])}
                              >
                                <InputLabel id="demo-simple-select-required-label">
                                  {botInterpretedWatch === "n" ||
                                  botInterpretedWatch === "" ? (
                                    "Bot Name"
                                  ) : (
                                    <ReuseableLabel label={"Bot Name"} />
                                  )}
                                </InputLabel>
                                <Controller
                                  name="Bot Name"
                                  control={control}
                                  defaultValue=""
                                  render={({ field }) => (
                                    <>
                                      <Select
                                        {...field}
                                        labelId="demo-simple-select-required-label"
                                        id="demo-simple-select-required"
                                        label="Bot Name"
                                        defaultValue=""
                                        disabled={
                                          botNameDisabled ? true : false
                                        }
                                        style={{ height: "43px" }}
                                        size="small"
                                        error={Boolean(errors?.["Bot Name"])}
                                      >
                                        <MenuItem value={""}>
                                          Please select an option
                                        </MenuItem>
                                        <MenuItem value={"yesOrNo"}>
                                          yesOrNo
                                        </MenuItem>
                                        <MenuItem value={"checkNumeric#years"}>
                                          checkNumeric#years
                                        </MenuItem>
                                        <MenuItem value={"income"}>
                                          income
                                        </MenuItem>
                                        <MenuItem value={"noticePeriod"}>
                                          noticePeriod
                                        </MenuItem>
                                        <MenuItem value={"checkGptResponse"}>
                                          checkGptResponse
                                        </MenuItem>
                                        <MenuItem value={"voiceScore"}>
                                          Communication Score
                                        </MenuItem>
                                        <MenuItem value={"videoScore"}>
                                          Video Score
                                        </MenuItem>
                                      </Select>
                                      {errors?.["Bot Name"] && (
                                        <FormHelperText error>
                                          {errors?.["Bot Name"]?.message}
                                        </FormHelperText>
                                      )}
                                    </>
                                  )}
                                />
                              </FormControl>
                            </Box>
                            <FormControl
                              variant="outlined"
                              style={{ marginTop: 11, minWidth: 150 }}
                              size="small"
                              error={Boolean(errors.Path)} // Added error prop
                            >
                              <InputLabel id="demo-simple-select-required-label">
                                <ReuseableLabel label={"Path"} />
                              </InputLabel>
                              <Controller
                                name="Path"
                                control={control}
                                defaultValue=""
                                rules={{ required: "Please select an option" }}
                                render={({ field }) => (
                                  <>
                                    <Select
                                      {...field}
                                      labelId="demo-simple-select-required-label"
                                      id="demo-simple-select-required"
                                      label="Path"
                                      defaultValue=""
                                      style={{ height: "43px" }}
                                      error={Boolean(errors.Path)}
                                    >
                                      <MenuItem value={""}>
                                        Please select an option
                                      </MenuItem>
                                      <MenuItem value={"y"}>Yes</MenuItem>
                                      <MenuItem value={"n"}>No</MenuItem>
                                      <MenuItem value={"b"}>Both</MenuItem>
                                    </Select>
                                    {errors.Path && (
                                      <FormHelperText error>
                                        {errors.Path.message}
                                      </FormHelperText>
                                    )}
                                  </>
                                )}
                              />
                            </FormControl>
                            <FormControl
                              variant="outlined"
                              style={{ marginTop: 11, minWidth: 150 }}
                              size="small"
                              error={Boolean(errors.Adaptive)} // Added error prop
                            >
                              <InputLabel id="demo-simple-select-required-label">
                                <ReuseableLabel label={"Adaptive"} />
                              </InputLabel>
                              <Controller
                                name="Adaptive"
                                control={control}
                                defaultValue=""
                                rules={{ required: "Please select an option" }}
                                render={({ field }) => (
                                  <>
                                    <Select
                                      {...field}
                                      labelId="demo-simple-select-required-label"
                                      id="demo-simple-select-required"
                                      label="Adaptive"
                                      defaultValue=""
                                      style={{ height: "43px" }}
                                      error={Boolean(errors.Adaptive)}
                                    >
                                      <MenuItem value={""}>
                                        Please select an option
                                      </MenuItem>
                                      <MenuItem value={"y"}>Yes</MenuItem>
                                      <MenuItem value={"n"}>No</MenuItem>
                                    </Select>
                                    {errors.Adaptive && (
                                      <FormHelperText error>
                                        {errors.Adaptive.message}
                                      </FormHelperText>
                                    )}
                                  </>
                                )}
                              />
                            </FormControl>
                            <>
                              <FormControl
                                variant="outlined"
                                style={{ marginTop: 11, minWidth: 150 }}
                                size="small"
                                error={Boolean(errors.yPath)} // Added error prop
                              >
                                <InputLabel id="demo-simple-select-required-label">
                                  YPath
                                </InputLabel>
                                <Controller
                                  name="yPath"
                                  control={control}
                                  defaultValue=""
                                  render={({ field }) => (
                                    <>
                                      <Select
                                        {...field}
                                        labelId="demo-simple-select-required-label"
                                        id="demo-simple-select-required"
                                        label="YPath*"
                                        defaultValue=""
                                        style={{ height: "43px" }}
                                        error={Boolean(errors.yPath)}
                                      >
                                        <MenuItem value={""}>
                                          Please select an option
                                        </MenuItem>
                                        <MenuItem value={"0"}>0</MenuItem>
                                        <MenuItem value={"1"}>1</MenuItem>
                                      </Select>
                                      {errors.yPath && (
                                        <FormHelperText error>
                                          {errors.yPath.message}
                                        </FormHelperText>
                                      )}
                                    </>
                                  )}
                                />
                              </FormControl>
                              <FormControl
                                variant="outlined"
                                style={{ marginTop: 11, minWidth: 150 }}
                                size="small"
                                error={Boolean(errors.nPath)}
                              >
                                <InputLabel id="demo-simple-select-required-label">
                                  NPath
                                </InputLabel>
                                <Controller
                                  name="nPath"
                                  control={control}
                                  defaultValue=""
                                  render={({ field }) => (
                                    <>
                                      <Select
                                        {...field}
                                        labelId="demo-simple-select-required-label"
                                        id="demo-simple-select-required"
                                        label="NPath"
                                        defaultValue=""
                                        style={{ height: "43px" }}
                                        error={Boolean(errors.nPath)}
                                      >
                                        <MenuItem value={""}>
                                          Please select an option
                                        </MenuItem>
                                        <MenuItem value={"0"}>0</MenuItem>
                                        <MenuItem value={"1"}>1</MenuItem>
                                      </Select>
                                      {errors.nPath && (
                                        <FormHelperText error>
                                          {errors.nPath.message}
                                        </FormHelperText>
                                      )}
                                    </>
                                  )}
                                />
                              </FormControl>
                            </>
                          </Stack>
                        </Box>
                      </Box>
                      // NEW SECTION
                      <Box sx={{ border: "0px solid red" }}>
                        {" "}
                        // Added border
                        <Stack>
                          <FormControl
                            variant="outlined"
                            // Removed style={{ minWidth: "45%" }}
                            size="small"
                            error={Boolean(errors.questionType)}
                          >
                            <InputLabel id="demo-simple-select-required-label">
                              <ReuseableLabel label={"Question Type"} />
                            </InputLabel>
                            <Controller
                              name="questionType"
                              control={control}
                              defaultValue=""
                              rules={{ required: "Please select an option" }}
                              render={({ field }) => (
                                <>
                                  <Select
                                    {...field}
                                    labelId="demo-simple-select-required-label"
                                    id="demo-simple-select-required"
                                    label="Question Type*"
                                    defaultValue=""
                                    style={{ height: "43px" }}
                                    error={Boolean(errors.questionType)}
                                  >
                                    <MenuItem value={""}>
                                      Please select an option
                                    </MenuItem>
                                    <MenuItem value={"Default Question"}>
                                      Default Question
                                    </MenuItem>
                                    <MenuItem value={"Generic Question"}>
                                      Generic Question
                                    </MenuItem>
                                    <MenuItem value={"Profile Gap Question"}>
                                     Profile Gap Question
                                    </MenuItem>
                                    <MenuItem value={"Assessment Question"}>
                                     Assessment Question
                                    </MenuItem>
                                    <MenuItem value={"Job Specific Question"}>
                                      Job Specific Question
                                    </MenuItem>
                                    <MenuItem value={"POFU Question"}>
                                      POFU Question
                                    </MenuItem>
                                    <MenuItem value={"Offer Question"}>
                                      Offer Question
                                    </MenuItem>
                                    <MenuItem value={"Onboarding Question"}>
                                      Onboarding Question
                                    </MenuItem>
                                    <MenuItem value={"BlueCollar Question"}>
                                      BlueCollar Question
                                    </MenuItem>
                                    <MenuItem value={"Document Collection Question"}>
                                      Document Collection Question
                                    </MenuItem>
                                  </Select>
                                  {errors.questionType && (
                                    <FormHelperText error>
                                      {errors.questionType.message}
                                    </FormHelperText>
                                  )}
                                </>
                              )}
                            />
                          </FormControl>
                          // MANDATORY QUESTION
                          <FormControl
                            variant="outlined"
                            style={{ marginTop: 11, minWidth: 150 }}
                            size="small"
                            error={Boolean(errors.mandatoryQuestion)}
                          >
                            <InputLabel id="demo-simple-select-required-label">
                              Mandatory Question
                            </InputLabel>
                            <Controller
                              name="mandatoryQuestion"
                              control={control}
                              defaultValue=""
                              render={({ field }) => (
                                <>
                                  <Select
                                    {...field}
                                    labelId="mandatoryQuestion"
                                    id="mandatoryQuestionId"
                                    label="mandatoryQuestion"
                                    defaultValue=""
                                    style={{ height: "43px" }}
                                    error={Boolean(errors.mandatoryQuestion)}
                                  >
                                    <MenuItem value={""}>
                                      Please select an option
                                    </MenuItem>
                                    <MenuItem value={"yes"}>Yes</MenuItem>
                                    <MenuItem value={"no"}>No</MenuItem>
                                  </Select>
                                  {errors.mandatoryQuestion && (
                                    <FormHelperText error>
                                      {errors.mandatoryQuestion.message}
                                    </FormHelperText>
                                  )}
                                </>
                              )}
                            />
                          </FormControl>
                          // QUESTION EXPIRY
                          <FormControl
                            variant="outlined"
                            style={{ marginTop: 11, minWidth: 150 }}
                            size="small"
                            error={Boolean(errors.questionExpiry)}
                          >
                            <InputLabel id="demo-simple-select-required-label">
                              <ReuseableLabel label={"Question Expiry"} />
                            </InputLabel>
                            <Controller
                              name="questionExpiry"
                              control={control}
                              defaultValue=""
                              rules={{ required: "Please select an option" }}
                              render={({ field }) => (
                                <>
                                  <Select
                                    {...field}
                                    labelId="questionExpiry"
                                    id="questionExpiryId"
                                    label="Question Expiry*"
                                    defaultValue=""
                                    style={{ height: "43px" }}
                                    error={Boolean(errors.questionExpiry)}
                                  >
                                    <MenuItem value={""}>
                                      Please select an option
                                    </MenuItem>
                                    <MenuItem value={"never"}>Never</MenuItem>
                                    // Changed labels to include 'days'
                                    <MenuItem value={"15"}>15 days</MenuItem>
                                    <MenuItem value={"30"}>30 days</MenuItem>
                                    <MenuItem value={"90"}>90 days</MenuItem>
                                    <MenuItem value={"180"}>180 days</MenuItem>
                                    <MenuItem value={"365"}>365 days</MenuItem>
                                  </Select>
                                  {errors.questionExpiry && (
                                    <FormHelperText error>
                                      {errors.questionExpiry.message}
                                    </FormHelperText>
                                  )}
                                </>
                              )}
                            />
                          </FormControl>
                        </Stack>
                      </Box>
                    </Stack>
                  </>
                  */
                  // REPLACED WITH SHARED COMPONENT
                  <BasicSection
                    control={control}
                    errors={errors}
                    watch={watch}
                    setValue={setValue}
                    register={register}
                    isEditMode={true}
                    defaultValues={questionData || {}}
                    PrettoSlider={PrettoSlider}
                  />
                ) : (
                  /*
                  // --- GENERAL SECTION CONTENT ---
                  <>
                    <Stack
                      direction={"column"}
                      gap={2}
                      // Added responsive width and margin auto
                      width={{
                        md: "80%",
                        lg: "80%",
                        xl: "80%",
                        sm: "100%",
                        xs: "100%",
                      }}
                      margin={"0 auto"}
                      mt={"20px"}
                    >
                      // Removed General Section Typography Header
                      <Box>
                        <Stack direction="column" spacing={1}>
                          <TextField
                            fullWidth
                            // multiline // Removed multiline
                            variant="outlined"
                            label="Acknowledgement"
                            type="text"
                            placeholder="Acknowledgement"
                            // Removed inputProps
                            size="small"
                            {...register("Ack")} // Removed rules
                            error={Boolean(errors.Ack)}
                            helperText={errors.Ack?.message}
                          />
                          <TextField
                            fullWidth
                            // multiline // Removed multiline
                            variant="outlined"
                            type="text"
                            placeholder="Default Value"
                            label={
                              isContainsDDollar ? (
                                <ReuseableLabel label="Default Value" />
                              ) : (
                                "Default Value"
                              )
                            }
                            defaultValue=""
                            // Removed inputProps
                            size="small"
                            {...register("defaultValue", {
                              required: isContainsDDollar
                                ? "Default Value is Required"
                                : null,
                            })}
                            error={Boolean(errors.defaultValue)}
                            helperText={errors.defaultValue?.message}
                          />
                          <Box
                            style={{
                              marginTop: 10,
                              minWidth: 150,
                              border: "1px solid #908E8E",
                              borderRadius: "7px",
                              height: "43px",
                            }}
                          >
                            <Stack direction={"row"} spacing={2} padding={1.2}>
                              <Typography
                                sx={{
                                  paddingTop: "1px",
                                  paddingLeft: "5px",
                                  opacity: "0.7",
                                  display: "flex",
                                  gap: "2px",
                                }}
                              >
                                Weightage{" "}
                                <span style={{ color: "red" }}> *</span>
                              </Typography>

                              <PrettoSlider
                                valueLabelDisplay="auto"
                                aria-label="pretto slider"
                                sx={{ color: "blue" }}
                                min={0.1}
                                step={0.1}
                                max={1}
                                defaultValue={data?.Weight || 0.5} // ✅ Default value from your data
                                style={{ width: "80%", marginLeft: "8%" }}
                                {...register("Weight", {
                                  required: "Weight is Required",
                                  valueAsNumber: true, // ✅ ensures it's treated as a number
                                })}
                              />
                            </Stack>
                          </Box>

                          // PROCESS VARIABLES
                          <Box
                            sx={{
                              border: "0px solid green",
                              display: "flex",
                              alignItems: "center",
                              gap: "5px",
                            }}
                          >
                            {processVariableWatch?.length > 0 && (
                              <InfoBox
                                message={getMasterTooltipMessage(
                                  "processVariable",
                                  "processVariable"
                                )}
                              />
                            )}
                            <Controller
                              name="Process_Variable" // ✅ Better to avoid space in field name
                              control={control}
                              render={({ field }) => (
                                <Autocomplete
                                  {...field}
                                  value={data?.["Process Variable"] || ""} // ✅ safely read from your fetched data
                                  onChange={(event, newValue) =>
                                    setData((d) => ({
                                      ...d,
                                      "Process Variable": newValue || "",
                                    }))
                                  }
                                  options={processVariables || []} // ✅ array of variable options
                                  getOptionLabel={(option) => option || ""}
                                  disablePortal
                                  fullWidth
                                  size="small"
                                  renderInput={(params) => (
                                    <TextField
                                      {...params}
                                      label="Process Variable"
                                      error={!!errors?.["Process_Variable"]}
                                      helperText={
                                        errors?.["Process_Variable"]?.message
                                      }
                                    />
                                  )}
                                />
                              )}
                            />
                          </Box>
                          // Scoring Engine Field Name
                          // <Box
                            sx={{
                              border: "0px solid green",
                              display: "flex",
                              alignItems: "center",
                              gap: "5px",
                            }}
                          >
                            <InfoBox
                              message={getMasterTooltipMessage(
                                "scoringEngineFieldName",
                                "scoringEngineFieldName"
                              )}
                            />
                            <TextField
                              fullWidth
                              variant="outlined"
                              label="Scoring Engine Field Name"
                              type="text"
                              value={watch("Scoring Engine Field Name") || ""}
                              placeholder="Scoring Engine Field Name"
                              inputProps={{
                                style: {
                                  // backgroundColor: "white",
                                },
                              }}
                              size="small"
                              {...register("Scoring Engine Field Name")}
                              error={Boolean(
                                errors?.["Scoring Engine Field Name"]
                              )}
                              helperText={
                                errors?.["Scoring Engine Field Name"]?.message
                              }
                            />
                          </Box>
                           <Box
                            sx={{
                              border: "0px solid green",
                              display: "flex",
                              alignItems: "center",
                              gap: "5px",
                            }}
                          >
                         <FormControlLabel
                          control={
                         <Checkbox
                          size="small"
                          {...register("Scoring Engine")}
                           />
                           }
                          label="Scoring Engine"
                          />
                          </Box>
                          // Next Question Prefix
                          <TextField
                            fullWidth
                            // multiline // Removed multiline
                            variant="outlined"
                            type="text"
                            placeholder="Next Question Prefix" // Corrected Placeholder
                            label="Next Question Prefix"
                            // Removed inputProps
                            size="small"
                            {...register("Next Question Prefix")} // Removed rules
                            error={Boolean(errors?.["Next Question Prefix"])}
                            helperText={
                              errors?.["Next Question Prefix"]?.message
                            }
                          />
                          // Help Text
                          <TextField
                            fullWidth
                            // multiline // Removed multiline
                            variant="outlined"
                            type="text"
                            placeholder="Help Text"
                            label="Help Text"
                            // Removed inputProps
                            size="small"
                            {...register("Help Text")} // Removed rules
                            error={Boolean(errors?.["Help Text"])}
                            helperText={errors?.["Help Text"]?.message}
                          />
                          // Expect Document and Categories
                          <Stack direction="column" spacing={1}>
                            <FormControl
                              variant="outlined"
                              style={{ marginTop: 1, minWidth: 150 }}
                              size="small"
                              error={Boolean(errors.expectDocument)}
                            >
                              <InputLabel id="demo-simple-select-required-label">
                                Expect Document
                              </InputLabel>
                              <Controller
                                name="expectDocument"
                                control={control}
                                defaultValue=""
                                render={({ field }) => (
                                  <>
                                    <Select
                                      {...field}
                                      labelId="demo-simple-select-required-label"
                                      id="demo-simple-select-required"
                                      label="Expect Document"
                                      defaultValue=""
                                    >
                                      <MenuItem value={""}>
                                        Please select an option
                                      </MenuItem>
                                      <MenuItem value={"yes"}>Yes</MenuItem>
                                      <MenuItem value={"no"}>No</MenuItem>
                                    </Select>
                                  </>
                                )}
                              />
                            </FormControl>
                            <FormControl
                              variant="outlined"
                              style={{ marginTop: 11, minWidth: 150 }}
                              size="small"
                              error={Boolean(errors.documentCategory)}
                            >
                              <InputLabel id="documentType">
                                Document Categories
                              </InputLabel>
                              <Controller
                                name="documentCategory"
                                control={control}
                                defaultValue="" // Added defaultValue
                                // Removed rules - already present
                                render={({ field }) => (
                                  <>
                                    <Select
                                      {...field}
                                      labelId="documentCategory"
                                      id="documentCategoryId" // Corrected id
                                      label="Document Categories"
                                      // Removed defaultValue
                                      style={{ height: "43px" }}
                                      error={Boolean(errors.documentCategory)}
                                      disabled={
                                        expectDocumentWatch !== "yes"
                                          ? true
                                          : false
                                      }
                                    >
                                      {documentCategories.map((cate, idx) => {
                                        return (
                                          <MenuItem key={idx} value={cate.code}>
                                            {cate.name}
                                          </MenuItem>
                                        );
                                      })}
                                    </Select>
                                    {errors.documentCategory && (
                                      <FormHelperText error>
                                        {errors.documentCategory.message}
                                      </FormHelperText>
                                    )}
                                  </>
                                )}
                              />
                            </FormControl>
                            <>
                              {documentSubCategories.length > 0 && (
                                <FormControl
                                  variant="outlined"
                                  style={{ marginTop: 11, minWidth: 150 }}
                                  size="small"
                                  error={Boolean(errors.documentType)}
                                >
                                  <InputLabel id="documentType">
                                    Document Type
                                  </InputLabel>
                                  <Controller
                                    name="documentType"
                                    control={control}
                                    defaultValue=""
                                    render={({ field }) => (
                                      <>
                                        <Select
                                          {...field}
                                          labelId="documentType"
                                          id="documentType"
                                          label="Document Type"
                                          defaultValue=""
                                          style={{ height: "43px" }}
                                          error={Boolean(errors.documentType)}
                                          disabled={
                                            expectDocumentWatch !== "yes"
                                              ? true
                                              : false
                                          }
                                        >
                                          {documentSubCategories.map(
                                            (scate, idx) => {
                                              return (
                                                <MenuItem
                                                  key={idx}
                                                  value={scate.name}
                                                >
                                                  {scate.name}
                                                </MenuItem>
                                              );
                                            }
                                          )}
                                        </Select>
                                        {errors.documentType && (
                                          <FormHelperText error>
                                            {errors.documentType.message}
                                          </FormHelperText>
                                        )}
                                      </>
                                    )}
                                  />
                                </FormControl>
                              )}
                            </>
                          </Stack>
                          // Range Start/End
                          <Box
                            sx={{
                              // Removed border
                              display: "flex",
                              alignItems: "center",
                              gap: "5px",
                            }}
                          >
                            <InfoBox
                              message={getMasterTooltipMessage(
                                "range",
                                "range"
                              )}
                            />
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                gap: "25px",
                              }}
                            >
                              <TextField
                                // Removed fullWidth, multiline
                                variant="outlined"
                                type="number"
                                label="Range Start"
                                name="rangeStart"
                                size="small"
                                placeholder="Range Start"
                                InputProps={{
                                  sx: { borderRadius: "6px", width: "100%" },
                                }}
                                {...register("rangeStart")}
                                error={Boolean(errors.rangeStart)}
                                helperText={errors.rangeStart?.message}
                              />
                              <TextField
                                // Removed fullWidth, multiline
                                variant="outlined"
                                type="number"
                                label="Range End"
                                name="rangeEnd"
                                placeholder="Range End"
                                size="small"
                                InputProps={{
                                  sx: { borderRadius: "6px", width: "100%" },
                                }}
                                {...register("rangeEnd")}
                                error={Boolean(errors.rangeEnd)}
                                helperText={errors.rangeEnd?.message}
                              />
                            </Box>
                          </Box>
                        </Stack>
                      </Box>
                    </Stack>
                  </>
                  */
                  // REPLACED WITH SHARED COMPONENT
                  <OtherSection
                    control={control}
                    errors={errors}
                    watch={watch}
                    setValue={setValue}
                    register={register}
                    processVariableWatch={processVariableWatch}
                    processVariables={processVariables}
                    expectDocumentWatch={expectDocumentWatch}
                    documentCategories={documentCategories}
                    documentSubCategories={documentSubCategories}
                    isEditMode={true}
                    defaultValues={questionData || {}}
                  />
                )}
              </Stack>
            </Box>

            {/* --- ACTION BUTTONS --- */}
            {/* Removed outer Box */}
            <Stack
              direction={"row"}
              gap={6}
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                marginY: "20px", // Changed from 15px
              }}
            >
              <Button
                sx={{
                  width: "140px",
                  height: "41px",
                  // Swapped colors
                  backgroundColor: "primary.main",
                  color: "secondary.main",
                  boxShadow: "0px 4px 6px 0px rgba(0, 0, 0, 0.25)",
                  borderRadius: "8px",
                  fontSize: "15px",
                  fontWeight: "500",
                }}
                type="submit"
              >
                Update
              </Button>

              <Button
                sx={{
                  width: "140px",
                  height: "41px",
                  boxShadow: "0px 4px 6px 0px rgba(0, 0, 0, 0.25)",
                  borderRadius: "8px",
                  // Swapped colors
                  color: "primary.main",
                  backgroundColor: "secondary.main",
                  fontSize: "15px",
                  fontWeight: "500",
                }}
                onClick={() => navigate("/questions")}
              >
                Cancel
              </Button>
            </Stack>
          </form>
        )}
        {/* Removed !questionData spinner */}
        {/* Added DeleteAlert */}
        <DeleteAlert
          /*open={open}
          onClose={handleClose}
          handleClose={handleClose}
          handleDelete={handleSimilarQuestionSubmit}
          header={`${isSameQuestionExist ? "Same" : "Similar"} Question`}
          message={`${
            isSameQuestionExist ? "Same" : "Similar"
            // Updated message
          } question is available do you still want to save this question?`}
          rightButton={"Update"}
        />*/
          open={open}
          onClose={handleClose}
          handleClose={handleClose}
          handleDelete={handleSimilarQuestionSubmit}
          header={"Are you sure?"} // ✅ NEW HEADER
          message={"Are you sure you want to update this question?"} // ✅ NEW MESSAGE
          rightButton={"Yes, Update"} // ✅ NEW BUTTON TEXT
        />
      </Box>
    </Box>
  );
};

export default EditForm;
